import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import ReactHtmlParser from 'react-html-parser';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbIconRowInnerBlock = (props) => {
    const classes = useStyles();

    return <div className={`icon-list ${props.attributes.className ? props.attributes.className : ''} ${classes.iconRowInner} ${classes.iconRowInnerTheme}`}>
        {ReactHtmlParser(props.originalContent)}
        <span>{props.attributes.text}</span>
    </div>
};

export const CgbIconRowInnerBlockFragment = graphql`
  fragment CgbIconRowInnerBlock on WpBlock {
    ... on WpCgbIconRowInnerBlock {
        name
        originalContent
        attributes {
            className
            text
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbIconRowInnerBlockPreview = `
    ... on CgbIconRowInnerBlock {
        name
        originalContent
        attributes {
            className
            text
        }
    }
`;